import React, { Component } from "react";
import DKLabel from "./common/DKLabel";
import DKButton from "./common/DKButton";
import DKIcon from "./common/DKIcon";

class JobDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className="border-s border-radius-s p-l bg-white border-box width-48"
        style={{ margin: "1%" }}
      >
        <div className="row align-items-start">
          <DKIcon
            src={this.props.data.logo}
            className="mr-m ic-l border-radius-m border-ss bg-white"
          />
          <div className="column parent-width">
            <DKLabel text={this.props.data.title} className="fw-m" />
            <DKLabel text={this.props.data.position} className="mt-s" />
            <div className="row justify-content-between align-items-center mt-s">
              <DKLabel text={this.props.data.location} className="text-gray " />
              <DKButton className="border-m " title="See more" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default JobDetails;
